'use client';

import { useSelector } from 'react-redux';
import React, { useEffect, useCallback } from 'react';

import { endCall } from 'src/utils/call';

import { selectSessions } from 'src/store/slices/call-slice';

export const ReloadRestrictProvider = ({ children }) => {
  const sessions = useSelector(selectSessions); // now an array
  const isActive = sessions?.length > 0;

  const handleBeforeUnload = useCallback(
    (event) => {
      if (isActive) {
        event.returnValue =
          'An active call session is in progress. Are you sure you want to leave?';
      }
      return null;
    },
    [isActive]
  );

  const handleEndCall = useCallback(() => {
    if (isActive) {
      sessions.forEach((s) => endCall(s.id));
    }
  }, [isActive, sessions]);

  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('unload', handleEndCall);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleEndCall);
    };
  }, [handleBeforeUnload, handleEndCall, isActive, sessions]);

  return <>{children}</>;
};
